import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { ApiMiniPaymentMethodsTransformer } from './api-mini-payment-methods.transformer';

import { ApiPaymentMethods } from '@api/_api/api-order/api-order.models';
import { HttpRequestsService } from '@core/services/http-requests/http-requests.service';

@Injectable()
export class ApiMiniPaymentMethodsService {
    constructor(
        private readonly http: HttpClient,
        private readonly requestService: HttpRequestsService,
        private readonly transformer: ApiMiniPaymentMethodsTransformer,
    ) {}

    public images(
        storeId: string,
        languageId: string,
        orderId: string,
        sort: string[]
    ): Observable<Array<[string, string]>> {
        // hay que cambiar el numero de pedido segun lo que haya ahora mismo
        const slug = `order/store/${storeId}/order/${orderId}/payment`;
        const url = this.requestService.requestUrl(slug, languageId);
        return this.http.get<ApiPaymentMethods>(url, { withCredentials: true }).pipe(
            map(data => this.transformer.fromApi(data, sort)),
        );
    }
}
